var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnualTour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Annual_Tour",
    "data-name": "Annual Tour",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#fff8f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "world-tour",
    transform: "translate(478 191.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9878",
    "data-name": "Path 9878",
    d: "M44.134,52.867H2A21.085,21.085,0,0,1,23.067,31.8a7.8,7.8,0,0,1,1.291.068A21.007,21.007,0,0,1,44.134,52.867Z",
    transform: "translate(0 -9.164)",
    fill: "none",
    stroke: "#d66b01",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9879",
    "data-name": "Path 9879",
    d: "M38.051,52.9c-.272-.544.136-1.223.2-1.835a2.946,2.946,0,0,0-.883-2.039c-.34-.476-.883-1.019-1.427-.815a1.855,1.855,0,0,0-.815.612,3.1,3.1,0,0,1-4.349-.272c-.136-.2-.272-.34-.408-.544l-.408-.815a2.661,2.661,0,0,0-.68-.544,3.328,3.328,0,0,1-.951-3.058,9.95,9.95,0,0,1,1.223-3.058,1.081,1.081,0,0,1,.612-.612c.272-.068.612.136.883.272a3.371,3.371,0,0,0,4.281-.883.819.819,0,0,1,.34-.34c.272-.136.544.136.815.272a3.773,3.773,0,0,0,2.854.34c.2-.068.34-.068.544-.136M3.8,45.831a1.665,1.665,0,0,0,1.359-.34,9.65,9.65,0,0,1,.883-.815,2.237,2.237,0,0,1,2.175-.136A3.479,3.479,0,0,1,9.78,46.1,2.9,2.9,0,0,0,10.8,47.462c.544.34,1.359.2,1.9.612a2.415,2.415,0,0,1,.748,1.087A10.3,10.3,0,0,1,14.537,52.9m10.4-21a1.76,1.76,0,0,1-.748,1.767,3.815,3.815,0,0,1-2.107.612,4.188,4.188,0,0,0-1.835.068c-1.019.476-1.087,2.039-2.039,2.514a3.93,3.93,0,0,0-.951.34c-.951.476-.951,1.835-1.631,2.65a2.937,2.937,0,0,1-2.446.612,6.644,6.644,0,0,0-2.582-.068c-.815.272-1.563,1.155-1.223,1.971s1.359.883,2.175.815a3.149,3.149,0,0,1,2.379.34c.748.68.544,2.039,1.359,2.65a2.209,2.209,0,0,0,2.243,0,5.167,5.167,0,0,1,2.243-.748c1.971.068,2.786,2.854,4.757,3.4.748.272,1.631.068,2.379.34A2.865,2.865,0,0,1,28.2,52.967",
    transform: "translate(-0.577 -9.196)",
    fill: "none",
    stroke: "#d66b01",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9880",
    "data-name": "Path 9880",
    d: "M44.134,62.8H2",
    transform: "translate(0 -19.097)",
    fill: "none",
    stroke: "#d66b01",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9881",
    "data-name": "Path 9881",
    d: "M16.472,18.772c-.815-.068-1.7-.2-2.514-.34L4.036,15.578,3.9,12.452,35.025,11.3a7.018,7.018,0,0,1,4.485,1.359l.883.68s3.874.34,3.4,2.718-4.417,2.854-4.417,2.854H24.423",
    transform: "translate(-0.609 -2.592)",
    fill: "none",
    stroke: "#d66b01",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9882",
    "data-name": "Path 9882",
    d: "M3.451,9.86,2.5,3.2H5.694L9.568,9.656",
    transform: "translate(-0.16)",
    fill: "none",
    stroke: "#d66b01",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9883",
    "data-name": "Path 9883",
    d: "M24.235,17.5,15.4,24.636l5.165.34,12.368-6.66",
    transform: "translate(-4.294 -4.582)",
    fill: "none",
    stroke: "#d66b01",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnualTour);
export default __webpack_public_path__ + "static/media/AnnualTour.ea040f79ca1ad486d10861768ff8094a.svg";
export { ForwardRef as ReactComponent };